import './portal-edge-fonts-and-colors-card.scss';
import { FC } from "react";
import Card from "../../../../../components/layouts/card/card";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import {
    FONT_COLOR,
    FONT_VARIANT,
} from "../../../../../components/fonts/font-props";
import { FormField } from "../../../../../components/form-field/form-field";
import ControlGroupWithPreview from "../../../../../components/layouts/control-group-with-preview/control-group-with-preview";
import fonts_and_colors_preview_edge from "../../../../../images/previews/fonts-and-colors-portal-edge.svg";
import fonts_and_colors_preview_edge_feedback from "../../../../../images/previews/fonts-and-colors-feedback-portal-edge.svg";
import ColorPickerInput from "../../color-picker-input/color-picker-input";
import customizationStore from "../../../../../stores/customizations/customization-store";
import { Input } from "../../../../../components/inputs/input/input";
import ListLayout from "../../../../../components/layouts/list-layout/list-layout";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import { observer } from "mobx-react";
import Hr from "../../../../../components/hr/hr";

interface IPortalEdgeFontsAndColorsCardProps {
    isExpanded: boolean;
    onExpandedChange: (isExpanded: boolean) => void;
}

const PortalEdgeFontsAndColorsCard: FC<IPortalEdgeFontsAndColorsCardProps> = observer(({isExpanded, onExpandedChange}) => {
    const edgeCustomizationStore = customizationStore.getEdgeStore();

    return (
        <div className="portal-edge-fonts-and-colors-card">
            <Card
                toolbar={{
                    title: (
                        <FontBody1
                            color={FONT_COLOR.PRIMARY2}
                            variant={FONT_VARIANT.BOLD}
                        >
                            Fonts and Colors
                        </FontBody1>
                    ),
                }}
                isExpanded={isExpanded}
                expandCallback={onExpandedChange}
            >
                <FormField
                    label=""
                    instructions="Customize your portal fonts and colors"
                    children={null}
                />

                <ControlGroupWithPreview
                    hasTopBorder={false}
                    gridStyle={{
                        childrenWidth: { width: 1 },
                        previewWidth: { width: 1 },
                    }}
                    preview={
                        <div className="preview">
                            <img src={fonts_and_colors_preview_edge} alt="" />
                        </div>
                    }
                >
                    <ListLayout>
                        <FormField label="Text" children={null} />
                        <FormFieldLine label="Font">
                            <Input
                                value={edgeCustomizationStore.font}
                                onChange={edgeCustomizationStore.setFont}
                            />
                        </FormFieldLine>
                        <FormFieldLine label="Title">
                            <ColorPickerInput
                                value={edgeCustomizationStore.titleColor}
                                onChange={edgeCustomizationStore.setTitleColor}
                            />
                        </FormFieldLine>
                        <FormFieldLine label="Text">
                            <ColorPickerInput
                                value={edgeCustomizationStore.textColor}
                                onChange={edgeCustomizationStore.setTextColor}
                            />
                        </FormFieldLine>

                        <Hr />

                        <FormField label="Input fields" children={null} />

                        <FormFieldLine label="Input Text">
                            <ColorPickerInput
                                value={edgeCustomizationStore.inputTextColor}
                                onChange={edgeCustomizationStore.setInputTextColor}
                            />
                        </FormFieldLine>
                        <FormFieldLine label="Input Background">
                            <ColorPickerInput
                                value={edgeCustomizationStore.inputBackgroundColor}
                                onChange={
                                    edgeCustomizationStore.setInputBackgroundColor
                                }
                            />
                        </FormFieldLine>

                        <Hr />

                        <FormField label="Brand" children={null} />

                        <FormFieldLine label="Primary button">
                            <ColorPickerInput
                                value={edgeCustomizationStore.buttonBackgroundColor}
                                onChange={
                                    edgeCustomizationStore.setButtonBackgroundColor
                                }
                            />
                        </FormFieldLine>
                        <FormFieldLine label="Button Text">
                            <ColorPickerInput
                                value={edgeCustomizationStore.buttonTextColor}
                                onChange={edgeCustomizationStore.setButtonTextColor}
                            />
                        </FormFieldLine>

                        <Hr />

                        <FormField label="Bars" children={null} />

                        <FormFieldLine label="Header Bar">
                            <ColorPickerInput
                                value={edgeCustomizationStore.headerBackgroundColor}
                                onChange={
                                    edgeCustomizationStore.setHeaderBackgroundColor
                                }
                            />
                        </FormFieldLine>
                        <FormFieldLine label="Footer Bar">
                            <ColorPickerInput
                                value={edgeCustomizationStore.footerBackgroundColor}
                                onChange={
                                    edgeCustomizationStore.setFooterBackgroundColor
                                }
                            />
                        </FormFieldLine>
                    </ListLayout>
                </ControlGroupWithPreview>

                <div className="feedback-layout">
                    <Hr />

                    <ControlGroupWithPreview
                        hasTopBorder={false}
                        gridStyle={{
                            childrenWidth: { width: 1 },
                            previewWidth: { width: 1 },
                        }}
                        preview={
                            <div className="preview">
                                <img
                                    src={fonts_and_colors_preview_edge_feedback}
                                    alt=""
                                />
                            </div>
                        }
                    >
                        <ListLayout>
                            <FormField label="Feedback" children={null} />

                            <FormFieldLine label="Error State">
                                <ColorPickerInput
                                    value={edgeCustomizationStore.errorColor}
                                    onChange={edgeCustomizationStore.setErrorColor}
                                />
                            </FormFieldLine>

                            <FormFieldLine label="Success State">
                                <ColorPickerInput
                                    value={edgeCustomizationStore.successColor}
                                    onChange={edgeCustomizationStore.setSuccessColor}
                                />
                            </FormFieldLine>
                        </ListLayout>
                    </ControlGroupWithPreview>
                </div>
            </Card>
        </div>
    );
});

export default PortalEdgeFontsAndColorsCard;
